import { render } from "./estatus.vue?vue&type=template&id=3c1a602e"
import script from "./estatus.vue?vue&type=script&lang=js"
export * from "./estatus.vue?vue&type=script&lang=js"

import "./estatus.vue?vue&type=style&index=0&id=3c1a602e&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__